export default __webpack_public_path__ + "static/media/message-error.540ea2c8.svg";